import React from "react";
import OverviewDesktop from "./Desktop";

const Overview = () => {
  return <>{ <OverviewDesktop />}</>;
};

export default Overview;
